import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { SessionHomeRedirectService } from "@core/services/session-home-redirect.service";

export const GuestGuard: CanActivateFn = () => inject(SessionHomeRedirectService).guestCanActivate$();
